export class Pillar {
  id!: string;
  name!: string;
}
